/** Checklist override API. Deal ids are encoded; the server never joins them onto a path. */
async function call(path, { method = 'GET', body } = {}) {
  const res = await fetch(`/api/deals/${path}`, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try {
    data = await res.json();
  } catch {
    /* empty */
  }
  if (!res.ok) {
    const err = new Error(data?.detail ? String(data.detail) : `HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const fetchOverrides = (dealId) =>
  call(`${encodeURIComponent(dealId)}/checklist/overrides`);

export const putOverride = (dealId, body) =>
  call(`${encodeURIComponent(dealId)}/checklist/overrides`, { method: 'PUT', body });
